export default "__VITE_ASSET__g88Y$BCc__"